// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-7f48e256]{display:flex!important;flex-direction:column}.overflow[data-v-7f48e256]{flex-grow:1;overflow:auto}.dialogTop[data-v-7f48e256]{bottom:30px;right:25px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
